// @flow
/* eslint-disable ta-code-conventions/has-matching-test, ta-code-conventions/has-matching-storydoc */
import { buildTripModal } from './modals';

/** Function to build the path to Trips page */
export const build = buildTripModal(
  (
    servlet: string,
    {
      tripId,
      tripTitle,
      ...params
    }: { tripId: number, tripTitle: string, [string]: string | number },
  ) => {
    let path = servlet;
    if (tripId) {
      path += `/${tripId}`;
      if (tripTitle) {
        path += `/${encodeURIComponent(tripTitle)}`;
      }
    }
    return { path, ...params };
  },
);

/** Function to parse tripId and tripTitle */
export const parse = (tripId: number, tripTitle: string) => ({ tripId, tripTitle });
